import UaeKycAPI from '@/api/uae-kyc'

const state = {
  provider: '',
}

const getters = {
  provider: (state) => state.provider,
}

const mutations = {
  SET_PROVIDER(state, value) {
    state.provider = value
  },
}

const actions = {
  async logUserAction(_, { sessionId, event }) {
    const { data, header } = await UaeKycAPI.logUserAction(sessionId, event)
    return { data, header }
  },
  setProvider({ commit }, value) {
    commit('SET_PROVIDER', value)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
